"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuePropertyDecorator = require("vue-property-decorator");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var SCRIPT_URL = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit'; // NOTE: the Cloudflare script is loaded once for the whole app, every widget waits for the same promise

var scriptPromise = null;

function loadScript() {
  if (window.turnstile) {
    return Promise.resolve(window.turnstile);
  }

  if (!scriptPromise) {
    scriptPromise = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = SCRIPT_URL;
      script.async = true;
      script.defer = true;

      script.onload = function () {
        return resolve(window.turnstile);
      };

      script.onerror = function () {
        // NOTE: a blocked script may load fine on the next try, so the promise is not kept
        scriptPromise = null;
        reject();
      };

      document.head.appendChild(script);
    });
  }

  return scriptPromise;
}

var TurnstileComponent = /*#__PURE__*/function (_Vue) {
  (0, _inherits2.default)(TurnstileComponent, _Vue);

  var _super = _createSuper(TurnstileComponent);

  function TurnstileComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, TurnstileComponent);
    _this = _super.apply(this, arguments); // NOTE: a widget that cannot reach Cloudflare is hidden, n8n can switch Turnstile off so the login still works

    _this.hasFailed = false;
    _this.widgetId = null;
    _this.isUnmounted = false;
    return _this;
  } // NOTE: the dev and prod keys differ, each server's .env carries its own


  (0, _createClass2.default)(TurnstileComponent, [{
    key: "siteKey",
    get: function get() {
      return process.env.VUE_APP_CLOUDFLARE_KEY || '';
    }
  }, {
    key: "language",
    get: function get() {
      switch (this.$i18n.locale) {
        case 'sc':
          return 'zh-cn';

        case 'tc':
          return 'zh-tw';

        default:
          return 'en';
      }
    }
  }, {
    key: "isDarkTheme",
    get: function get() {
      return Boolean(this.$store.getters['common/isDarkTheme']);
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.renderWidget();
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      this.isUnmounted = true;
      this.removeWidget(); // NOTE: the token of a removed widget is still single use, the login page must not keep it

      this.$emit('expire');
    }
  }, {
    key: "getTurnstile",
    value: function getTurnstile() {
      return window.turnstile;
    }
  }, {
    key: "renderWidget",
    value: function renderWidget() {
      var _this2 = this;

      if (!this.siteKey) {
        return;
      }

      this.hasFailed = false;
      loadScript().then(function (turnstile) {
        var widget = _this2.$refs.widget; // NOTE: the login page may have moved on (e.g. to the OTP step) while the script was still loading

        if (_this2.isUnmounted || _this2.widgetId || !widget) {
          return;
        }

        _this2.widgetId = turnstile.render(widget, {
          sitekey: _this2.siteKey,
          language: _this2.language,
          theme: _this2.isDarkTheme ? 'dark' : 'light',
          size: 'flexible',
          callback: function callback(token) {
            _this2.hasFailed = false;

            _this2.$emit('verify', token);
          },
          // NOTE: Cloudflare retries on its own, a recovered widget that needs a click is shown again
          'before-interactive-callback': function beforeInteractiveCallback() {
            _this2.hasFailed = false;
          },
          'expired-callback': function expiredCallback() {
            return _this2.$emit('expire');
          },
          'error-callback': function errorCallback() {
            _this2.$emit('expire');

            _this2.onFailed();
          }
        });
      }).catch(function () {
        return _this2.onFailed();
      });
    }
  }, {
    key: "onFailed",
    value: function onFailed() {
      this.hasFailed = true;
      this.$emit('error');
    } // NOTE: a token is only good for one login call, the next call needs the widget to be solved again

  }, {
    key: "reset",
    value: function reset() {
      var turnstile = this.getTurnstile();

      if (this.widgetId && turnstile) {
        turnstile.reset(this.widgetId);
      }

      this.$emit('expire');
    }
  }, {
    key: "removeWidget",
    value: function removeWidget() {
      var turnstile = this.getTurnstile();

      if (this.widgetId && turnstile) {
        turnstile.remove(this.widgetId);
      }

      this.widgetId = null;
    }
  }]);
  return TurnstileComponent;
}(_vuePropertyDecorator.Vue);

TurnstileComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'TurnstileComponent'
})], TurnstileComponent);
var _default = TurnstileComponent;
exports.default = _default;